// extracted by mini-css-extract-plugin
export default {"Product_modal_slider":"ProductModalSlider_Product_modal_slider__739Ro"};